// QUICK ADD BUTTONS
var isSubmitting = false; // flag to indicate if an AJAX call is currently in progress

function findVatByCountryCode(code) {
    const result = vatData.find(item => item.country_code === code);
    return result ? result.vat_value : null;
}

function getCountryCode(callback) {
    fetch('https://pro.ip-api.com/json/?fields=61439&key=4K0RiYSqq5OzvRV')
        .then(response => response.json())
        .then(data => {
            const countryCode = data.countryCode;
            callback(countryCode);
        })
        .catch(error => {
            callback(null); // Handle the error by passing null to the callback
        });
}

function updateCartMessage() {
    getCountryCode(function (countryCode) {
        const showContainer = document.getElementById("cartMsgContainer");

        if (!countryCode) {
            showContainer.style.display = "none";
            return;
        }

        const vatValue = findVatByCountryCode(countryCode);
        if (vatValue) {
            showContainer.style.display = "flex"; // Show the container if VAT exists
        } else {
            showContainer.style.display = "none"; // Hide the container if VAT does not exist
        }
    });
}

// Call updateCartMessage on page load to set the initial state
document.addEventListener('DOMContentLoaded', function () {
    updateCartMessage();
});

$(document).on('submit', '#quickShopForm', function (e) {
    e.preventDefault(); // prevent the form from submitting normally

    if (isSubmitting) {
        return; // if an AJAX call is already in progress, do nothing
    }

    isSubmitting = true; // set the flag to indicate that an AJAX call is now in progress
    $(this).find('button[type="submit"]').prop('disabled', false); // disable the submit button
    var formData = $(this).serialize(); // get the form data
    var currentForm = $(this); // store a reference to the current form

    // Update VAT message before submitting
    updateCartMessage();

    $.ajax({
        type: 'POST',
        url: '/cart/add.js', // Shopify cart API endpoint for adding products
        data: formData,
        dataType: 'json',
        success: function () {
            $.ajax({
                type: 'GET',
                dataType: 'html',
                success: function (html) {
                    $('#CartDrawer').html($(html).find('#CartDrawer').html());
                    var cart = new theme.CartDrawer();
                    cart.init();
                    cart.open();
                }
            });
            currentForm.find('button[type="submit"]').prop('disabled', false); // re-enable the submit button
            isSubmitting = false; // set the flag to indicate that the AJAX call is now complete
        },
        error: function () {
            isSubmitting = false; // reset flag on error
        }
    });
});

$(document).on('change', 'input[type="radio"]', function () {
    $(this).closest('form').submit(); // automatically submit the form when a radio button is selected
});